var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "g-pesquisa",
        {
          ref: "refPesquisa",
          attrs: {
            id: "refPesquisa",
            name: "refPesquisa",
            filtroAdicional: _vm.getFiltroPesquisa,
            limparFiltroLocal: _vm.limparFiltro,
            colunasPropriedade: _vm.colunas,
            apiPesquisa: _vm.apiSubAssunto,
            operacoes: _vm.operacoes,
            exibirColunaOperacoes: _vm.exibirColunaOperacoes,
            elementosPorPagina: _vm.elementosPorPagina,
            novo: _vm.cadastrarItem,
            imprimir: _vm.imprimir,
            showTermoPesquisa: false,
            carregamentoInicial: false,
            showBuscaAvancadaAberta: true,
            showBotaoNovo: _vm.permissaoPerfil.incluir
          }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12" },
              [
                _c("g-input", {
                  ref: "refDescricao",
                  attrs: {
                    id: "refDescricao",
                    name: "refDescricao",
                    tipo: "text",
                    etiqueta: "Descrição",
                    foco: false,
                    tamanho: 100,
                    chamarFuncaoNoEnter: _vm.pesquisarPrimeiraPagina
                  },
                  model: {
                    value: _vm.subAssunto.desSubassunto,
                    callback: function($$v) {
                      _vm.$set(_vm.subAssunto, "desSubassunto", $$v)
                    },
                    expression: "subAssunto.desSubassunto"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 col-xs-12" },
              [
                _c("g-autocomplete", {
                  ref: "refAssunto",
                  attrs: {
                    id: "refAssunto",
                    name: "refAssunto",
                    etiqueta: "Assunto",
                    valor: "codAssunto",
                    descricaoPrimaria: "desAssunto",
                    desabilitar: _vm.paginaStatus.desabilitarEdicao,
                    api: _vm.apiAssunto
                  },
                  model: {
                    value: _vm.subAssunto.assunto.codAssunto,
                    callback: function($$v) {
                      _vm.$set(_vm.subAssunto.assunto, "codAssunto", $$v)
                    },
                    expression: "subAssunto.assunto.codAssunto"
                  }
                })
              ],
              1
            )
          ]),
          _c("br")
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }